import { render, staticRenderFns } from "./OutrightsMenuTreeItem.vue?vue&type=template&id=372f0204"
import script from "./OutrightsMenuTreeItem.vue?vue&type=script&lang=js"
export * from "./OutrightsMenuTreeItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports